class TabbedCarousel extends HTMLElement {
  constructor() {
    super();

    this.slides = this.querySelectorAll("carousel-slider, testimonials-carousel");
    this.tabs = this.querySelectorAll(".js-carousel-tab");
    this.controlWrappers = this.querySelectorAll(".js-carousel-control-wrapper");
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const tabIndex = tab.getAttribute("data-tab-index");
        this.tabClick(tabIndex);
      });
    });
  }

  tabClick(activeTab) {
    this.tabs.forEach((tab) => {
      if (activeTab == tab.getAttribute("data-tab-index")) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });

    this.slides.forEach((slide, index) => {
      if (activeTab == 1 && index == 0) {
        slide.style.left = "-100%";
      } else {
        slide.style.left = "-" + 100 * activeTab + "%";
      }
    });

    this.controlWrappers.forEach((controlWrapper) => {
      const index = controlWrapper.getAttribute("data-tab-index");

      activeTab == index
        ? controlWrapper.classList.remove("hidden")
        : controlWrapper.classList.add("hidden");
    });
  }
}

customElements.define("carousel-tabbed", TabbedCarousel);
